import { UPDATE_FULLSCREEN_STATUS } from './actions';

export default function reducer(state = false, action) {
    switch(action.type) {
        case UPDATE_FULLSCREEN_STATUS:
            return action.payload.isFullscreen;
        default:
            return state;
    }
}